/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const COMPLETE_CHASE_PAY_CHECKOUT = 'mbp-checkout/CHASEPAY/COMPLETE/CHECKOUT';

export default {};
